import React from "react";
import { CONSTANTS_STRINGS } from "src/constants";
import { useCheckoutDataContext } from "src/providers/SharedDataProvider";
import useNavigateCheckout from "src/hooks/useNavigateCheckout";
import useRefresh from "src/hooks/useRefresh";
import { toast } from "sonner";
import { useQueryClient } from "@tanstack/react-query";
import {
  LayoutCard,
  LayoutCardHeader,
  MainLayout,
} from "src/components/layout";
import { InfoCard } from "src/components/shared";
import { CaptionMLow } from "src/components/ui/typographic";

const REFRESH_INTERVAL = 3000;

const PreAuthorizationWaitingPage: React.FC = () => {
  const paymentInfo = useCheckoutDataContext();
  const queryClient = useQueryClient();
  useNavigateCheckout(paymentInfo);

  useRefresh({
    interval: REFRESH_INTERVAL,
    onRefresh: () => {
      toast.info("Verificando status do pagamento...");
      void queryClient.invalidateQueries({
        queryKey: ["checkout"],
      });
    },
  });
  return (
    <MainLayout>
      <LayoutCard>
        <LayoutCardHeader className="font-bold">
          {CONSTANTS_STRINGS.PRE_AUTHORIZATION_WAITING_TITLE}
        </LayoutCardHeader>

        <p className="items-start">
          {CONSTANTS_STRINGS.PRE_AUTHORIZATION_WAITING_SUBTITLE}
        </p>
        <InfoCard>
          <CaptionMLow className="text-brand-blue-1">
            {CONSTANTS_STRINGS.PRE_AUTHORIZATION_WAITING_MESSAGE}
          </CaptionMLow>
        </InfoCard>
      </LayoutCard>
    </MainLayout>
  );
};

export default PreAuthorizationWaitingPage;
